module.exports = __webpack_public_path__ + "static/media/folder.21db3b38.svg";